import { message } from 'antd';
import { useHrEmployeeStore } from '../stores/hr-employee-store';
import { customInstance } from '@/shared/api/mutator/custom-instance';
import { Department, Position } from '../types';

export function useDepartments() {
  const { departments, positions, setDepartments, setPositions } = useHrEmployeeStore();

  const fetchDepartments = async () => {
    try {
      const data = await customInstance<Department[]>({ url: '/api/hr/departments', method: 'GET' });
      setDepartments(data);
      return data;
    } catch {
      message.error('Failed to load departments');
    }
  };

  const createDepartment = async (dto: Partial<Department>) => {
    try {
      await customInstance<Department>({ url: '/api/hr/departments', method: 'POST', data: dto });
      message.success('Department created');
      await fetchDepartments();
    } catch {
      message.error('Failed to create department');
    }
  };

  const updateDepartment = async (id: number, dto: Partial<Department>) => {
    try {
      await customInstance<Department>({ url: `/api/hr/departments/${id}`, method: 'PUT', data: dto });
      message.success('Department updated');
      await fetchDepartments();
    } catch {
      message.error('Failed to update department');
    }
  };

  const deleteDepartment = async (id: number) => {
    try {
      await customInstance({ url: `/api/hr/departments/${id}`, method: 'DELETE' });
      message.success('Department deleted');
      await fetchDepartments();
    } catch {
      message.error('Failed to delete department');
    }
  };

  const fetchPositions = async () => {
    try {
      const data = await customInstance<Position[]>({ url: '/api/hr/positions', method: 'GET' });
      setPositions(data);
      return data;
    } catch {
      message.error('Failed to load positions');
    }
  };

  return { departments, positions, fetchDepartments, fetchPositions, createDepartment, updateDepartment, deleteDepartment };
}
